import { createGlobalStyle } from 'styled-components';
import { colors, fontSizes } from '../styles';

export const GlobalStyle = createGlobalStyle`
  body {
    font-family:  ${({ bodyFont }) => bodyFont || 'Arial, sans-serif'};
    font-size: ${fontSizes.paragraph.medium.fontSize};
    line-height: ${fontSizes.paragraph.medium.lineHeight};
    color: ${colors.midnightBlack};
    -webkit-font-smoothing: antialiased;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${({ headerFont }) => headerFont || 'Palatino, serif'};
    font-weight: normal;
    font-style: normal;
  }

  h1 {
    font-size: ${fontSizes.h1.fontSize};
    line-height: ${fontSizes.h1.lineHeight};
  }

  h2 {
    font-size: ${fontSizes.h2.fontSize};
    line-height: ${fontSizes.h2.lineHeight};
  }

  h3 {
    font-size: ${fontSizes.h3.fontSize};
    line-height: ${fontSizes.h3.lineHeight};
  }

  h4 {
    font-size: ${fontSizes.h4.fontSize};
    line-height: ${fontSizes.h4.lineHeight};
  }

  h5 {
    font-size: ${fontSizes.h5.fontSize};
    line-height: ${fontSizes.h5.lineHeight};
  }

  h6 {
    font-size: ${fontSizes.h6.fontSize};
    line-height: ${fontSizes.h6.lineHeight};
  }

  label {
    font-size: ${fontSizes.label.small.fontSize};
    line-height: ${fontSizes.label.small.lineHeight};
    font-weight: bold;
    color: ${colors.gray1};
  }

  input {
    font-family: ${({ headerFont }) => headerFont || 'Palatino, serif'};
    font-size: ${fontSizes.input.small.fontSize};
    line-height: ${fontSizes.input.small.lineHeight};
    font-weight: 600;
  }
`;
